var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckCircled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#3CDD9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2069 4.79303C12.3944 4.98056 12.4997 5.23487 12.4997 5.50003C12.4997 5.76519 12.3944 6.0195 12.2069 6.20703L7.20692 11.207C7.01939 11.3945 6.76508 11.4998 6.49992 11.4998C6.23475 11.4998 5.98045 11.3945 5.79292 11.207L3.79292 9.20703C3.61076 9.01843 3.50997 8.76583 3.51224 8.50363C3.51452 8.24143 3.61969 7.99062 3.8051 7.80521C3.99051 7.6198 4.24132 7.51463 4.50352 7.51236C4.76571 7.51008 5.01832 7.61087 5.20692 7.79303L6.49992 9.08603L10.7929 4.79303C10.9804 4.60556 11.2348 4.50024 11.4999 4.50024C11.7651 4.50024 12.0194 4.60556 12.2069 4.79303Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#3CDD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircled);
export default __webpack_public_path__ + "static/media/icon-check-circled.9b7f70b7f5f1f3de89426c18a81eee33.svg";
export { ForwardRef as ReactComponent };